import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { AddTimeBasedRouteModule } from '../add-time-based-route/add-time-based-route.module';
import { ExtensionTimeBasedRoutesComponent } from './extension-time-based-routes.component';

@NgModule({
   declarations: [ExtensionTimeBasedRoutesComponent],
   exports: [ExtensionTimeBasedRoutesComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      FileUrlPipeModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      AddTimeBasedRouteModule,
   ],
})
export class ExtensionTimeBasedRoutesModule {}
